import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, CheckCircle2, CreditCard } from 'lucide-react';
import { Countdown } from './Countdown';
import { PlanSelector } from './PlanSelector';
export function Pricing() {
  return <section id="ofertas" className="py-10 md:py-20 px-4 bg-white" data-id="element-262">
      <div className="max-w-5xl mx-auto" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-red-600 text-white p-3 md:p-4 rounded-lg text-center mb-5 md:mb-8" data-id="element-264">
          <p className="font-bold mb-1 md:mb-2 text-xs md:text-base" data-id="element-265">
            Oferta en vivo +$10.000 DESPUÉS LANZAMIENTO TERMINA EN
          </p>
          <Countdown className="text-lg md:text-2xl font-bold" data-id="element-266" />
          <p className="mt-1 md:mt-2 text-[10px] md:text-sm" data-id="element-267">
            Y no vuelve a bajar
          </p>
        </motion.div>

        <div className="mb-5 md:mb-6" data-id="element-268">
          <p className="text-center text-gray-700 mb-2 text-xs md:text-base" data-id="element-269">
            Cupos restantes <span className="font-bold" data-id="element-270">68% TOMADOS</span>
          </p>
          <div className="w-full bg-gray-200 rounded-full h-2 md:h-3" data-id="element-271">
            <div className="bg-gold h-2 md:h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-272" />
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-10" data-id="element-273">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark mb-2 md:mb-3" data-id="element-274">
            Elegí tu Más Allá de la Voluntad
          </h2>
          <p className="text-gray-700 text-xs md:text-base" data-id="element-275">
            Ambas opciones incluyen los 6 bonos estratégicos completos
          </p>
        </motion.div>

        <PlanSelector anchorStandard={29990} anchorPremium={39990} data-id="element-276" />

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-[10px] md:text-sm text-gray-600 mt-6 md:mt-8" data-id="element-277">
          <span className="flex items-center gap-1" data-id="element-278">
            <Lock className="w-3 h-3 md:w-4 md:h-4" data-id="element-279" /> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-280">
            <Zap className="w-3 h-3 md:w-4 md:h-4" data-id="element-281" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1" data-id="element-282">
            <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4" data-id="element-283" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-284">
            <CreditCard className="w-3 h-3 md:w-4 md:h-4" data-id="element-285" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}